import { render } from "./recordModal.vue?vue&type=template&id=2ec00e60&scoped=true"
import script from "./recordModal.vue?vue&type=script&lang=js"
export * from "./recordModal.vue?vue&type=script&lang=js"

import "./recordModal.vue?vue&type=style&index=0&id=2ec00e60&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec00e60"]])

export default __exports__